import { render, staticRenderFns } from "./RsaConfigurazionePostiLettoStanzeViewPage.vue?vue&type=template&id=5c006b03"
import script from "./RsaConfigurazionePostiLettoStanzeViewPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazionePostiLettoStanzeViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports